import { ScreenURL } from "./route_list";
import { lazy } from "react";
import { RouteProps } from "react-router-dom";

const routes_commons: Array<RouteProps> = [
  {
    path: ScreenURL.HOME,
    exact: true,
    component: lazy(() => import("../screens/HomeScreen/index")),
  },
  {
    path: ScreenURL.SHARING,
    exact: true,
    component: lazy(
      () => import("../screens/Features/DocumentSharingScreen/index")
    ),
  },
  {
    path: ScreenURL.AUTHENTICATION,
    exact: true,
    component: lazy(
      () => import("../screens/Features/DocumentAuthenticationScreen/index")
    ),
  },
  {
    path: ScreenURL.INSIGHT,
    exact: true,
    component: lazy(
      () => import("../screens/Features/DocumentInsightScreen/index")
    ),
  },
  {
    path: ScreenURL.PRICING,
    exact: true,
    component: lazy(() => import("../screens/PricingScreen/index")),
  },
  {
    path: ScreenURL.CONTACT,
    exact: true,
    component: lazy(() => import("../screens/ContactScreen/index")),
  },
];

export { routes_commons };
